module.exports = __webpack_public_path__ + "img/6.56d3e9e8.jpg";